import axios from 'axios'

import { ROUTES } from 'settings/settings'
import { LogService } from 'services/Log/Log'

export async function deleteUser(username: string) {
  try {
    const { data } = await axios({
      method: 'DELETE',
      url: `/${ROUTES.users}/${username}`,
      baseURL: process.env.REACT_APP_USER_API,
    })

    return { data }
  } catch (error: any) {
    LogService.error({ message: 'deleteUser', error })
    return { data: null, error: error.response?.data?.message }
  }
}
